import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { environment } from "./utils/variables";
import ReactGA from "react-ga";

ReactGA.initialize("UA-128203228-7");

Sentry.init({
  dsn: "https://fc9fbbf59928495eaf81a3311afa4831@o241222.ingest.sentry.io/5434072",
  environment,
  ignoreErrors: [
    /^TypeError: Failed to execute 'connect' on 'AudioNode': Overload resolution failed.$/,
    /^TypeError: Cannot read properties of null (reading 'connect')$/,
    /^TransportError: TransportError (31009): No transport available to send or receive messages$/,
    /^UnknownError: UnknownError (31000): An unknown error has occurred. See error details for more information.$/,
    /Token Expired/i,
    // Non error. Consensus seems that it's ok to ignore this
    //  https://stackoverflow.com/questions/71837472/non-error-promise-rejection-captured-with-value-undefined
    /Non-Error promise rejection captured/i,
    /Cannot unset input device while a call is in progress/i,
    //https://sellfire-inc.sentry.io/issues/2814007400/?project=5434072&query=is%3Aunresolved%20issue.priority%3Ahigh&referrer=issue-stream&sort=freq&stream_index=2
    /^TypeError: Cannot read properties of null (reading 'info')$/,
    // Pendo storage listener error - third party error we don't control
    /^TypeError: Cannot read properties of undefined \(reading 'startsWith'\)$/,
    // when tab goes to background, this error is thrown. Twilio related and non critical/no user impact observed.
    /^Could not refresh auth token: Network Error$/,
    // Twilio auth token refresh error - similar to above but with "twilio" in the message
    /^Could not refresh twilio auth token$/,
    // LogRocket session replay error on iOS Safari - third party error we don't control
    /^TypeError: null is not an object \(evaluating 'e.getAttribute'\)$/,
    // Ignore 401 Unauthorized errors as they are expected in certain scenarios
    /Request failed with status code 401/i,
    // Network fetch errors - common due to connectivity issues, timeouts, etc.
    /^Failed to fetch$/,
    // Chrome extension related fetch errors - caused by third-party browser extensions
    /chrome-extension.*Failed to fetch/i,
    // Browser storage quota exceeded - browser limitation, not application error
    /QuotaExceededError.*Storage.*quota/i,
  ],
  // Security PenTest: don't leak token to third party vendors
  beforeSend(event) {
    const currentUrl = window.location.href;

    if (currentUrl.includes("new-password")) {
      if (event?.request?.url) {
        const splitURL = event.request.url.split("?");
        const baseURL = splitURL[0] ?? "";
        event.request.url = splitURL.length > 1 ? baseURL : "";
      }
      if (event?.request?.headers?.Referer) {
        event.request.headers.Referer = "";
      }

      if (event?.breadcrumbs) {
        event.breadcrumbs = [];
      }
    }

    return event;
  },
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
